import { useGetIdentity } from "@refinedev/core";
import { Navigate } from "react-router";
import type { UserInfo } from "../types/auth";
import {
  AUDITOR_USER_TYPES,
  isCyberAdmin,
  isEurosemillasScoped,
} from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

interface Props {
  /** Componente para el landing por defecto (Cyber Admin, comercial…). */
  fallback: React.ReactNode;
}

/**
 * Home routing por rol:
 *   · Cyber Admin (user_type=1) → fallback (Home admin habitual).
 *   · Auditores (4, 5) → /dashboard.
 *   · Eurosemillas (ESA Admin con portfolio) → /dashboard (misma
 *     página que auditor pero con datos scopeados por portfolio
 *     via backend).
 *   · Resto (ESA sin portfolio, comercial…) → fallback.
 */
export const RoleBasedHomeRedirect = ({ fallback }: Props) => {
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();
  if (isLoading) return <LoadingSpinner fullScreen tip="Loading..." />;

  const userType = identity?.app_user?.user_type ?? -1;
  const isAuditor = (AUDITOR_USER_TYPES as readonly number[]).includes(userType);
  const isEsaScoped = isEurosemillasScoped(identity);

  // Cyber Admin siempre al fallback (Home admin).
  if (isCyberAdmin(identity)) {
    return <>{fallback}</>;
  }
  if (isAuditor || isEsaScoped) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{fallback}</>;
};
